const headerPopups = {
  accountBtn: document.getElementById('jsUserBtn') as HTMLElement,
  accountWrap: document.getElementById('jsUserWrap') as HTMLElement,
  cartBtn: document.getElementById('jsCartBtn') as HTMLElement,
  cartWrap: document.getElementById('jsCartWrap') as HTMLElement,
  helpBtn: document.getElementById('jsHelpBtn') as HTMLElement,
  helpWrap: document.getElementById('jsHelpWrap') as HTMLElement,

  init() {
    this.setHoverState();
    this.removeHoverState();
  },

  setHoverState() {
    this.accountBtn.addEventListener(
      'mouseenter',
      this.handleAccountHover.bind(this),
    );
    this.cartBtn.addEventListener(
      'mouseenter',
      this.handleCartHover.bind(this),
    );

    this.helpBtn.addEventListener(
      'mouseenter',
      this.handleHelpHover.bind(this),
    );
  },

  handleAccountHover() {
    this.accountWrap.classList.add('activeClass');
    this.cartWrap.classList.remove('activeClass');
    this.helpWrap.classList.remove('activeClass');
  },

  handleCartHover() {
    this.cartWrap.classList.add('activeClass');
    this.accountWrap.classList.remove('activeClass');
    this.helpWrap.classList.remove('activeClass');
  },

  handleHelpHover() {
    this.helpWrap.classList.add('activeClass');
    this.accountWrap.classList.remove('activeClass');
    this.cartWrap.classList.remove('activeClass');
  },

  removeHoverState() {
    window.addEventListener('mouseover', this.handleMouseOut.bind(this));
  },

  handleMouseOut(e) {
    const target = e.target as HTMLElement;

    if (!this.isHoveredElement(target)) {
      this.accountWrap.classList.remove('activeClass');
      this.cartWrap.classList.remove('activeClass');
      this.helpWrap.classList.remove('activeClass');
    }
  },

  isHoveredElement(target: HTMLElement): boolean {
    return [
      this.accountBtn,
      this.accountWrap,
      this.cartBtn,
      this.cartWrap,
      this.helpBtn,
      this.helpWrap,
    ].some((element) => element === target || element.contains(target));
  },
};

export default headerPopups;
